import { Box, BoxProps, Flex, FlexProps, Text } from '@chakra-ui/react';
import { isNumber } from 'lodash';
import { Country } from '~/types';
import { formatPercentage } from '~/utils';

import { FlagIconLabel } from './components/FlagIconLabel';

interface Props extends BoxProps {
  overallTopCountries: Country<number>[];
  title?: string;
  iconsContainerProps?: FlexProps;
}

export const TopCountries: React.FC<Props> = ({
  overallTopCountries = [],
  title,
  iconsContainerProps,
  ...props
}) => {
  const MAX_FLAG_ICONS = 3;
  const countries =
    overallTopCountries.length > 0
      ? overallTopCountries
      : Array.from(Array(MAX_FLAG_ICONS).keys());

  return (
    <Box {...props} data-testid="top-countries-section">
      {title && (
        <Text
          fontSize="md"
          fontWeight="medium"
          textTransform="uppercase"
          lineHeight="14px"
          letterSpacing="wide"
        >
          {title}
        </Text>
      )}

      <Flex marginTop={4} gap="2.156rem" {...iconsContainerProps}>
        {countries.map((country, index) => {
          if (isNumber(country)) {
            return <FlagIconLabel key={`empty-state-flag-${index}`} />;
          }

          return (
            <FlagIconLabel
              countryCode={country.label}
              countryName={country.meta?.countryName}
              value={formatPercentage(country.value, undefined, 1)}
              key={`${country.label}-${index}`}
            />
          );
        })}
      </Flex>
    </Box>
  );
};
